import { render } from "./product-information.vue?vue&type=template&id=dfa1e51a"
import script from "./product-information.vue?vue&type=script&lang=js"
export * from "./product-information.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Work/Sneak-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__